import { combineReducers } from '@reduxjs/toolkit';
import authenticationReducer from './slices/authentication';
import billingReducer from './slices/billing-slice';
import ecomsReducer from './slices/ecoms-slice';
import enabledShippingTypes from './slices/enabled-shipping-types/enabled-shipping-types.reducer';
import errorBanner from './slices/error-banner/error-banner.reducer';
import hostSlice from './slices/host-slice';
import intercomReducer from './slices/intercom-slice';
import packageProvidersReducer from './slices/package-providers/package-providers.reducer';
import planLimitsCountReducer from './slices/plan-limits-counter';
import settingsReducer from './slices/settings-slice';
import shopifyAppPricingReducer from './slices/shopify-app-pricing/shopify-app-pricing.reducer';
import shopifyReviewDialog from './slices/shopify-review-dialog/shopify-review-dialog.reducer';
import thirdPartyFulfillmentSettingsReducer from './slices/third-party-fulfillment-settings/third-party-fulfillment-settings.reducer';
import translationReducer from './slices/translation-slice';
import wizardReducer from './slices/wizard-slice';

const rootReducer = combineReducers({
    authentication: authenticationReducer,
    ecoms: ecomsReducer,
    billing: billingReducer,
    settings: settingsReducer,
    wizard: wizardReducer,
    translation: translationReducer,
    planLimitsCount: planLimitsCountReducer,
    hostSlice: hostSlice,
    intercom: intercomReducer,
    errorBanner,
    shopifyReviewDialog,
    packageProviders: packageProvidersReducer,
    thirdPartyFulfillmentSettings: thirdPartyFulfillmentSettingsReducer,
    shopifyAppPricing: shopifyAppPricingReducer,
    enabledShippingTypes,
});

export default rootReducer;
